import {
  FETCH_COMMUNITY_ABOUT,
  FETCH_COMMUNITY_ABOUT_SUCCESS,
  FETCH_COMMUNITY_ABOUT_FAILURE,
} from './actionTypes';
import { createAuthenticatedApiInstance } from 'src/utils/api';
import * as log from 'loglevel';
import { setAlert } from 'src/typescript/components/alert/actions';

export const fetchCommunityAbout = (slug) => {
  return async (dispatch, getState) => {
    dispatch({
      type: FETCH_COMMUNITY_ABOUT,
    });
    try {
      const api = createAuthenticatedApiInstance(getState);
      const state = getState();
      const currentUser = state.context.currentUser;
      const isMember = !!currentUser && !!currentUser.followedCommunities.find(x => x.slug === slug);
      const url = `communities/${slug}/about`;

      const { data: { description, supportingMembers, support, contact } } = !isMember
        ? await api.getPublic(url)
        : await api.get(`private/${url}`);

      dispatch({
        type: FETCH_COMMUNITY_ABOUT_SUCCESS,
        description,
        supportingMembers,
        support,
        contact,
      });
    } catch (error) {
      log.error(error);
      dispatch({
        type: FETCH_COMMUNITY_ABOUT_FAILURE,
      });
      dispatch(setAlert(error.message));
    }
  };
};


